import React from "react";
import "./CondPopUpStyle.css";

interface Props {
  vm: any;
}

const CondPopupView: React.FC<Props> = ({ vm }) => {
  return (
    <div className={`popup-background ${vm.isVisible ? "visible" : ""}`}>
      <div className="popup-container">
        <h2>Änderungen an Bedingungen</h2>
        <p>Bitte bestätigen Sie die Änderungen:</p>

        <div className="checkbox-table">
          {vm.agbStatus !== 1 && (
            <div className="checkbox-row">
              <input
                type="checkbox"
                checked={vm.agbChecked}
                onChange={(e) => vm.setAgbChecked(e.target.checked)}
              />
              <span>Ich akzeptiere die AGB</span>
            </div>
          )}

          {vm.dsgvoStatus !== 1 && (
            <div className="checkbox-row">
              <input
                type="checkbox"
                checked={vm.dsgvoChecked}
                onChange={(e) => vm.setDsgvoChecked(e.target.checked)}
              />
              <span>Ich akzeptiere die Datenschutzerklärung</span>
            </div>
          )}

          {vm.useCondStatus !== 1 && (
            <div className="checkbox-row">
              <input
                type="checkbox"
                checked={vm.useCondChecked}
                onChange={(e) => vm.setUseCondChecked(e.target.checked)}
              />
              <span>Ich akzeptiere die Nutzungsbedingungen</span>
            </div>
          )}
        </div>

        <button className="accept-button" onClick={vm.confirm}>
          Bestätigen
        </button>
      </div>
    </div>
  );
};

export default CondPopupView;